<template>
    <div>
        <h3 v-if="title != null">{{ title }}</h3>
        <div class="tags">
            <a
                v-for="option in options"
                :key="option.value"
                @click="selectOption(option)"
                :class="{ ativo: modelValue === option.value }"
            >
                {{ option.label }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "SelectableTags",
    props: {
        title: { type: String, default: null },
        options: {
            type: Array,
            required: true,
            validator(value) {
                return value.every((option) => "value" in option && "label" in option);
            },
        },
        modelValue: { type: [Object, String, Number], default: null },
        onSelect: { type: Function, default: null },
    },
    watch: {
        options: {
            immediate: true,
            handler(newOptions) {
                if (!this.modelValue && newOptions.length > 0) {
                    this.$emit("update:modelValue", newOptions[0].value);
                }
            },
        },
    },
    methods: {
        selectOption(option) {
            this.$emit("update:modelValue", option.value);
            if (this.onSelect != null) {
                this.onSelect(option);
            }
        },
    },
};
</script>
